import Vue from 'vue'

export default {
    async getTodos({ commit }, isAnswer) {
        const todos = await Vue.axios.get('/biz/home/needDeal/list', { params: { isAnswer } })
        commit("setTodo", todos.result);
    },
    async getUndoneTodos({ commit }) {
        const todos = await Vue.axios.get('/biz/home/needDeal/list', { params: { isAnswer: 0 } })
        commit("setUndoneTodoLength", todos.result.documentList ? todos.result.documentList.length : 0);
    },
    
}


// WEBPACK FOOTER //
// ./src/store/actions.js